var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGeography(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1084",
    "data-name": "Rectangle 1084",
    width: 39.338,
    height: 32.446,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_geography",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(334.164 224.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209-2",
    "data-name": "Group 209",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1083",
    "data-name": "Rectangle 1083",
    width: 37.557,
    height: 24.202,
    rx: 1.225,
    transform: "translate(0.891 7.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21831",
    "data-name": "Path 21831",
    d: "M5.946,3.481A4.49,4.49,0,0,0,1.468,7.959V22.309h28.6a4.49,4.49,0,0,0,4.478-4.478V3.481Z",
    transform: "translate(3.899 9.245)",
    fill: "#f1c14f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21832",
    "data-name": "Path 21832",
    d: "M1.468,7.639v9.633l28.7.143a4.447,4.447,0,0,0,2.643-.954l1.4-1.886.336-5.868v-3.2l-.87-.19L29.114,8.312,22.131,10.8l-10.854.34L3.318,8.754Z",
    transform: "translate(3.899 14.132)",
    fill: "#e08c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21833",
    "data-name": "Path 21833",
    d: "M33.967,27.751H5.367A5.374,5.374,0,0,1,0,22.38V7.135A5.373,5.373,0,0,1,5.367,1.768h28.6a5.375,5.375,0,0,1,5.367,5.367V22.38a5.376,5.376,0,0,1-5.367,5.371M5.367,3.545a3.594,3.594,0,0,0-3.59,3.59V22.38a3.592,3.592,0,0,0,3.59,3.59h28.6a3.594,3.594,0,0,0,3.59-3.59V7.135a3.6,3.6,0,0,0-3.59-3.59Z",
    transform: "translate(0 4.696)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21834",
    "data-name": "Path 21834",
    d: "M17.9,4.954H16.126V2.661a.889.889,0,0,0-.888-.885H6.061a.885.885,0,0,0-.885.885V4.954H3.4V2.661A2.665,2.665,0,0,1,6.061,0h9.176A2.665,2.665,0,0,1,17.9,2.661Z",
    transform: "translate(9.019 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21835",
    "data-name": "Path 21835",
    d: "M19.454,13.5A28.692,28.692,0,0,1,.081,6.374l1.192-1.32a27.281,27.281,0,0,0,18.181,6.672A27.2,27.2,0,0,0,37.81,4.893L39.016,6.2a29,29,0,0,1-19.563,7.3",
    transform: "translate(0.215 12.995)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21836",
    "data-name": "Path 21836",
    d: "M5.459,11.757V7.867a2.66,2.66,0,1,1,3.762,0v3.89Z",
    transform: "translate(12.422 8.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21837",
    "data-name": "Path 21837",
    d: "M7.985,3.076A3.553,3.553,0,0,0,5.214,8.849v4.442h5.539V8.849A3.55,3.55,0,0,0,7.985,3.076M8.976,8.1v3.418H6.994V8.1a1.773,1.773,0,1,1,1.982,0",
    transform: "translate(11.779 8.17)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGeography);
export default __webpack_public_path__ + "static/media/ic_geography.bedbac0da3b53d70b5dbc5907f21c8db.svg";
export { ForwardRef as ReactComponent };